// extracted by css-extract-rspack-plugin
export default {"formWrapper":"AgentVerificationRejectModal_formWrapper__t6b5k","textWrapper":"AgentVerificationRejectModal_textWrapper__z5VY-"};